export default __webpack_public_path__ + "assets/github.de924288.svg";